module.exports = __webpack_public_path__ + "media/featured/Parents-32944821.png";